var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, NavigationButton, Token, Tooltip, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import EmojiOne from 'emojione';
import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import isEmail from 'validator/lib/isEmail';
import { getChannelMessageMaxLength } from 'app/utils/conversation';
import { analytics } from 'app/utils/segment';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { getEmailIntegrationLabel } from 'utils/emailIntegration';
import { getRequestID } from '../../shared/util/request';
import turndown from '../../shared/util/richTextField/components/utils/turndown-service';
import RichTextField from '../../shared/util/richTextField/containers/richTextField';
import AttachmentsFieldList from '../../shared/util/richTextField/containers/utils/attachmentsFieldList';
import { getConversationFormEmailInitialValues, getConversationFormName, getUniqueRecipientEmails, } from '../utils/conversationForm';
import ListUserEmailOptionsCcBcc from './ListUserEmailOptionsCcBcc';
import UserItem from './UserItem';
import './../styles/conversationForm.less';
const markdownReplacements = [
    [/\\/g, '\\\\'],
    [/\*/g, '\\*'],
    [/^-/g, '\\-'],
    [/^\+ /g, '\\+ '],
    [/^(=+)/g, '\\$1'],
    [/^(#{1,6}) /g, '\\$1 '],
    [/`/g, '\\`'],
    [/^~~~/g, '\\~~~'],
    [/\[/g, '\\['],
    [/\]/g, '\\]'],
    [/^>/g, '\\>'],
    [/^(\d+)\. /g, '$1\\. '],
];
const escapeMarkdown = (text) => markdownReplacements.reduce((search, replacement) => search.replace(replacement[0], replacement[1]), text);
const validate = (values, props) => {
    const errors = {};
    if (isEmpty(values)) {
        return errors;
    }
    if (props.metaConversation.conversation.initial_channel === 'contactform') {
        if (!props.fromEmails || props.fromEmails.length === 0) {
            if (props.pristine === false) {
                const message = props.profile.is_admin === true
                    ? `You do not have any email integration. Please add one at [settings/email](/settings/email).`
                    : `You do not have any email integration yet. Ask your administrator to add one.`;
                const options = {
                    title: 'You do not have an email in Dixa yet',
                    text: message,
                    className: 'danger',
                    icon: 'i-exclamation',
                };
                props.notificationAdd(options);
            }
            errors._error = 'Please add an email.';
        }
        else if (!values.fromEmail) {
            errors.fromEmail = { _error: 'Required' };
        }
        else if (values.fromEmail && isEmail(values.fromEmail) === false) {
            errors.fromEmail = { _error: 'From email is not valid' };
        }
    }
    if (props.metaConversation.conversation.initial_channel === 'email' ||
        props.metaConversation.conversation.initial_channel === 'contactform') {
        if (!props.fromEmails || props.fromEmails.length === 0) {
            if (props.pristine === false) {
                const message = props.profile.is_admin === true
                    ? `You do not have any email integration. Please add one at [settings/email](/settings/email).`
                    : `You do not have any email integration yet. Ask your administrator to add one.`;
                const options = {
                    title: 'You do not have an email in Dixa yet',
                    text: message,
                    className: 'danger',
                    icon: 'i-exclamation',
                };
                props.notificationAdd(options);
            }
            errors._error = 'Please add an email.';
        }
        else if (!values.fromEmail) {
            errors.fromEmail = { _error: 'Required' };
        }
        else if (values.fromEmail && isEmail(values.fromEmail) === false) {
            errors.fromEmail = { _error: 'From email is not valid' };
        }
    }
    return errors;
};
class ConversationForm extends React.Component {
    constructor(props) {
        super(props);
        this.setValidationState = (validation) => {
            this.setState({ validation });
        };
        this.adaptToMarkedFormat = (markdown) => {
            const lines = markdown.split('\n');
            const linesWithNewlineAfterQuotedLines = lines.reduce((acc, line) => {
                if (line.startsWith('>'))
                    return acc.concat([line, '\n']);
                return acc.concat([line]);
            }, []);
            return linesWithNewlineAfterQuotedLines.join('\n');
        };
        this.renderTemplate = (payload) => {
            if (!payload || !payload.content) {
                return Promise.reject('No content given');
            }
            const { content } = payload;
            return this.props.templatesRender({
                csid: this.props.metaConversation.conversation.id,
                content: content && typeof content === 'string' ? content : '',
            });
        };
        this.handleTypingEvent = () => {
            const { metaConversation } = this.props;
            if (metaConversation.conversation.initial_channel === 'widgetchat') {
                this.props.wsRequest({
                    type: 'conversation:typing',
                    params: {
                        csid: this.props.metaConversation.conversation.id,
                    },
                });
            }
        };
        this.toggleCC = () => {
            this.setState({ ccVisible: !this.state.ccVisible });
        };
        this.toggleBCC = () => {
            this.setState({ bccVisible: !this.state.bccVisible });
        };
        this.hideField = (targetName) => {
            if (targetName === 'cc') {
                this.setState({ ccVisible: true });
            }
            else if (targetName === 'bcc') {
                this.setState({ bccVisible: true });
            }
        };
        this.timeouts = [];
        turndown.escape = escapeMarkdown;
        this.state = {
            activeTab: 'reply',
            bccVisible: false,
            ccVisible: false,
            fileStatuses: {},
            validation: { touched: false, valid: false },
        };
        this.newEditorRef = React.createRef();
        this.handleValidatedMessageOnSendClick =
            this.handleValidatedMessageOnSendClick.bind(this);
        this.renderElementItem = this.renderElementItem.bind(this);
    }
    componentDidMount() {
        const { metaConversation } = this.props;
        if (metaConversation.isAssignedToMe) {
            this.setEditorText(metaConversation.tempMessage);
            this.focusEditor();
        }
        this.initializeForm();
    }
    componentWillUnmount() {
        const textContent = this.getEditorText();
        if (typeof textContent === 'string') {
            // Save message text.
            this.props.conversationSaveTempMessage(this.props.metaConversation.conversation.id, textContent.trim());
        }
        if (this.timeouts !== null) {
            for (const timeout of this.timeouts) {
                clearTimeout(timeout);
            }
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        var _a, _b, _c;
        if (this.props.metaConversation.conversation.id !==
            nextProps.metaConversation.conversation.id) {
            const textContent = this.getEditorText();
            if (typeof textContent === 'string') {
                // Save message text.
                this.props.conversationSaveTempMessage(this.props.metaConversation.conversation.id, textContent.trim());
            }
            this.setValidationState({ touched: false, valid: false });
        }
        const propsLiveAssessment = this.props.metaConversation.conversation.live_assesment;
        const propsEndUserIsNotConnected = propsLiveAssessment &&
            propsLiveAssessment.is_end_user_connected === false;
        const nextPropsLiveAssessment = nextProps.metaConversation.conversation.live_assesment;
        const nextPropsEndUserIsNotConnected = nextPropsLiveAssessment &&
            nextPropsLiveAssessment.is_end_user_connected === false;
        if (nextProps.metaConversation.conversation.initial_channel ===
            'widgetchat' &&
            nextProps.metaConversation.isAssignedToMe === true &&
            nextPropsEndUserIsNotConnected === true &&
            nextProps.metaConversation.conversation.status !== 'closed') {
            this.setValidationState({
                touched: true,
                valid: false,
                error: this.state.validation.error,
                warning: { type: 'offline' },
            });
        }
        else if (nextProps.metaConversation.conversation.initial_channel ===
            'widgetchat' &&
            nextProps.metaConversation.isAssignedToMe === true &&
            propsEndUserIsNotConnected === true &&
            nextPropsEndUserIsNotConnected === false &&
            nextProps.metaConversation.conversation.status !== 'closed') {
            this.setValidationState({ touched: false, valid: false });
        }
        // If the conversation is going from open to closed and we need to reset the tempMessage.
        if (this.props.metaConversation.conversation.id ===
            nextProps.metaConversation.conversation.id &&
            nextProps.metaConversation.conversation.is_closed === true &&
            this.props.metaConversation.conversation.is_closed === false) {
            // We allow to reply back to closed email conversations.
            if (this.props.metaConversation.conversation.initial_channel !== 'email') {
                this.clearEditorText(); // Clear the Editor.
                this.props.initialize({}); // Clear the to, from, cc and bcc.
            }
        }
        if (nextProps.hasFFElevioAiResponse && // Elevio ai responses enabled
            ((_c = (_b = (_a = nextProps.elevioAiResponseData) === null || _a === void 0 ? void 0 : _a.choices) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.text) && // Has valid incoming response
            this.props.elevioAiResponseData !== nextProps.elevioAiResponseData) {
            const currentText = this.getEditorText();
            this.setEditorText(`<p>${currentText}<br/>${nextProps.elevioAiResponseData.choices[0].text.replace(/\n/g, '<br/>')}</p>`);
        }
    }
    componentDidUpdate(prevProps) {
        var _a;
        const { metaConversation, fromEmails, formValues } = this.props;
        const hasNewConversationId = metaConversation.conversation.id !==
            prevProps.metaConversation.conversation.id;
        const areEventsRecentlyLoaded = prevProps.metaConversation.conversation.events.length === 0 &&
            metaConversation.conversation.events.length > 0;
        const areEmailsRecentlyLoaded = prevProps.fromEmails.length === 0 && fromEmails.length > 0;
        const isEmailBasedChannel = ['email', 'contactform'].includes((_a = metaConversation.conversation.initial_channel) !== null && _a !== void 0 ? _a : '');
        // (Re)initialize the form when csid changes or when the view loads
        if (isEmailBasedChannel &&
            isEmpty(formValues) &&
            (hasNewConversationId ||
                areEventsRecentlyLoaded ||
                areEmailsRecentlyLoaded)) {
            this.initializeForm();
        }
        if (metaConversation.isAssignedToMe && hasNewConversationId) {
            this.setEditorText(metaConversation.tempMessage);
            this.focusEditor();
        }
    }
    initializeForm() {
        const { metaConversation: { conversation }, fromEmails, initialize, } = this.props;
        initialize(getConversationFormEmailInitialValues(conversation, fromEmails));
    }
    getEditorText() {
        if (this.newEditorRef && this.newEditorRef.current) {
            const { current: newEditor } = this.newEditorRef;
            return newEditor.getText();
        }
        return null;
    }
    setEditorText(newText) {
        if (this.newEditorRef && this.newEditorRef.current) {
            this.newEditorRef.current.setText(newText);
        }
    }
    clearEditorText() {
        this.setEditorText('');
    }
    focusEditor() {
        this.timeouts.push(setTimeout(() => {
            if (this.newEditorRef && this.newEditorRef.current) {
                this.newEditorRef.current.focus();
            }
        }));
    }
    getMessageTextAndContentType() {
        const { hasFFWriteHTMLEmail } = this.props;
        const channel = this.props.metaConversation.conversation.initial_channel;
        const editorText = this.newEditorRef.current.getText().trim();
        if (['facebookmessenger', 'whatsapp'].includes(channel)) {
            console.warn('this.newEditorRef.current', this.newEditorRef.current);
            return {
                text: this.newEditorRef.current.getPlainText(),
                content_type: 'markdown',
            };
        }
        if (hasFFWriteHTMLEmail && ['email', 'contactform'].includes(channel)) {
            return {
                text: editorText,
                content_type: 'html',
            };
        }
        if ('messenger' === channel) {
            return {
                text: EmojiOne.shortnameToUnicode(editorText),
                content_type: 'html',
            };
        }
        return {
            text: turndown.turndown(editorText),
            content_type: 'markdown',
        };
    }
    isMaxLengthExceeded(text) {
        const initialChannel = this.props.metaConversation.conversation.initial_channel;
        const isPublicReply = this.props.metaConversation.conversation.isPublicReply;
        const channelMaxMessageLength = getChannelMessageMaxLength(initialChannel, isPublicReply);
        return text.length > channelMaxMessageLength;
    }
    handleValidatedMessageOnSendClick(values) {
        return __awaiter(this, void 0, void 0, function* () {
            const { text, content_type } = this.getMessageTextAndContentType();
            if (text && typeof text === 'string' && text.trim() !== '') {
                if (this.isMaxLengthExceeded(text)) {
                    this.setValidationState({
                        touched: true,
                        valid: false,
                        error: { type: 'length' },
                    });
                    return;
                }
                this.setValidationState({ touched: false, valid: false });
                if (this.props.isPublicReply) {
                    const { isCancelled } = yield this.props.showPublicReplyConfirmModal();
                    if (isCancelled) {
                        return;
                    }
                }
                this.preparePayloadAndSubmitMessage(values, text, content_type);
                this.props.reset();
                this.clearEditorText();
            }
            else {
                this.setValidationState({
                    touched: true,
                    valid: false,
                    error: { type: 'required' },
                });
            }
        });
    }
    parseAttachments(rawAttachments) {
        // Attachment
        const attachments = [];
        if (rawAttachments !== undefined &&
            Array.isArray(rawAttachments) === true) {
            for (const attachment of rawAttachments) {
                if (attachment !== undefined) {
                    attachments.push({
                        pretty_name: attachment.name,
                        url: attachment.relative_uri,
                    });
                }
            }
        }
        return attachments;
    }
    preparePayloadAndSubmitMessage(coversationValues, text, content_type) {
        const requestID = getRequestID();
        const payload = {
            requestID: requestID,
            frontend_id: requestID,
            message: text,
            content_type,
            csid: this.props.metaConversation.conversation.id,
            hasReceivedResponse: false,
            type: 'conversation:add_message',
            channel: this.props.metaConversation.conversation.initial_channel,
            author: this.props.profile,
        };
        if (this.props.metaConversation.conversation.initial_channel ===
            'contactform' ||
            this.props.metaConversation.conversation.initial_channel === 'email') {
            payload.from = coversationValues.fromEmail;
            payload.cc_list_v2 = getUniqueRecipientEmails(coversationValues.cc);
            payload.bcc_list_v2 = getUniqueRecipientEmails(coversationValues.bcc);
            payload.to_emails = getUniqueRecipientEmails(coversationValues.to);
        }
        const attachments = this.parseAttachments(coversationValues.attachments);
        if (attachments.length > 0) {
            payload.attachments_v2 = attachments;
        }
        this.props.conversationSubmitMessage(payload).then(() => {
            var _a, _b, _c, _d;
            analytics.conversationReplied({
                language: (_b = (_a = this.props.metaConversation.conversation) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.language,
                tags: (_c = this.props.metaConversation.conversation) === null || _c === void 0 ? void 0 : _c.tags,
                channel: (_d = this.props.metaConversation.conversation) === null || _d === void 0 ? void 0 : _d.initial_channel,
            });
        });
    }
    getToAddress() {
        var _a, _b;
        const { metaConversation, formValues } = this.props;
        let toEmail = '';
        let contactName = '';
        // First we check that the formValues has a to address.
        const uniqueTo = getUniqueRecipientEmails(formValues === null || formValues === void 0 ? void 0 : formValues.to);
        if ((_a = uniqueTo === null || uniqueTo === void 0 ? void 0 : uniqueTo[0]) === null || _a === void 0 ? void 0 : _a.email) {
            toEmail = uniqueTo[0].email;
            contactName = (_b = uniqueTo[0].name) !== null && _b !== void 0 ? _b : '';
            // We add the format name<email> if we also have a name.
            if (contactName) {
                toEmail = ` <${toEmail}>`;
            }
        }
        else {
            // For backwards compatibility we need to check attributes.to_email and attributes.from_email.
            if (metaConversation.conversation.attributes &&
                (metaConversation.conversation.attributes.to_email ||
                    metaConversation.conversation.attributes.from_email)) {
                toEmail =
                    metaConversation.conversation.direction === 'inbound'
                        ? metaConversation.conversation.attributes.from_email
                        : metaConversation.conversation.attributes.to_email;
            }
            if (metaConversation.requester && metaConversation.requester.name) {
                contactName = metaConversation.requester.name;
                if (toEmail) {
                    toEmail = ` <${toEmail}>`;
                }
            }
        }
        return contactName + toEmail;
    }
    renderElementItem(props) {
        return _jsx(UserItem, Object.assign({}, props));
    }
    getRequesterName() {
        var _a;
        return (_a = this.props.metaConversation.requester) === null || _a === void 0 ? void 0 : _a.name;
    }
    getRequesterHandleOrFallbackToName() {
        var _a, _b, _c, _d;
        const handle = (_d = (_c = (_b = (_a = this.props.metaConversation.conversation) === null || _a === void 0 ? void 0 : _a.additional_data) === null || _b === void 0 ? void 0 : _b.end_user_contact_point) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.screen_name;
        return handle ? `@${handle}` : this.getRequesterName();
    }
    render() {
        let noEmailIntegration = null;
        let showSubmitButton = false;
        let showTextAddresses = false;
        let disableSubmit = false;
        let submitBtnText = 'Send';
        let submitBtnTooltip = this.props.hasNewKeybindings ? (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "richTextEditor:send" }, { children: "Send" }))) : this.props.browser.os === 'Mac OS' ? ('Send (Cmd+Enter)') : ('Send (Ctrl+Enter)');
        const { composeEmailMeta, composeEmailFindUser, fromEmails, users, handleSubmit, touch, profile, metaConversation, personalSettings, formValues, asyncStatus, isUploadingAttachments, } = this.props;
        const { isAssignedToMe, conversation: { is_closed: conversationIsClosed, initial_channel: convInitialChannel, id: csid, }, } = metaConversation;
        if (asyncStatus.submit === 'loading' ||
            asyncStatus.close === 'loading' ||
            asyncStatus.getConversation === 'loading') {
            disableSubmit = true;
            submitBtnText = 'Loading';
        }
        else if (isUploadingAttachments) {
            disableSubmit = true;
            submitBtnText = 'Uploading';
            submitBtnTooltip = 'Uploading file attachments';
        }
        else if (this.props.isPublicReply) {
            submitBtnText = 'Send public reply';
        }
        if (this.props.asyncStatus.getConversation !== 'loading') {
            if (['widgetchat', 'messenger'].includes(convInitialChannel) &&
                isAssignedToMe &&
                conversationIsClosed === false) {
                if (personalSettings.submitMessageWithEnter === false) {
                    showSubmitButton = true;
                }
            }
            else if (convInitialChannel === 'contactform' && isAssignedToMe) {
                showSubmitButton = true;
                showTextAddresses = true;
            }
            else if (convInitialChannel === 'email' && isAssignedToMe) {
                showSubmitButton = true;
                showTextAddresses = true;
            }
            else if (['facebookmessenger', 'whatsapp', 'sms', 'twitter'].includes(convInitialChannel) &&
                isAssignedToMe) {
                if (personalSettings.submitMessageWithEnter === false) {
                    showSubmitButton = true;
                }
            }
        }
        if (fromEmails.length === 0 &&
            composeEmailMeta.getAllFrom === 'succeeded') {
            noEmailIntegration = (_jsxs("div", Object.assign({ className: "well well-sm text-center" }, { children: [_jsx("h5", { children: "No email integration found" }), profile.is_admin === true && (_jsx(NavigationButton, Object.assign({ navigate: () => this.props.navigate('/settings/email') }, { children: "Create one in email settings" })))] })));
        }
        const fromEmailOptions = fromEmails.map((fromEmail) => {
            return {
                value: fromEmail.email_address,
                label: getEmailIntegrationLabel(fromEmail),
            };
        });
        const rootClass = classnames({
            'conversation-form': true,
        }, this.props.className);
        const toggleCCButtonText = (this.state.ccVisible ? '-' : '+') + 'Cc';
        const toggleBCCButtonText = (this.state.bccVisible ? '-' : '+') + 'Bcc';
        return (_jsxs("form", Object.assign({ className: rootClass, name: "conversation-form", onSubmit: handleSubmit((values) => this.handleValidatedMessageOnSendClick(values)) }, { children: [showTextAddresses && (_jsxs("div", Object.assign({ className: "cc-bcc-wrapped-area" }, { children: [noEmailIntegration, _jsxs("span", Object.assign({ className: "cc-bcc-container" }, { children: [_jsx(Button, Object.assign({ type: "button", variant: "tertiary", onClick: this.toggleCC }, { children: toggleCCButtonText })), _jsx(Button, Object.assign({ type: "button", variant: "tertiary", onClick: this.toggleBCC }, { children: toggleBCCButtonText }))] })), _jsxs("div", Object.assign({ className: "cc-bcc-row" }, { children: [_jsx(Field, { primary: true, label: "From", required: true, options: fromEmailOptions, defaultOption: "Please select a from email", name: "fromEmail", component: Token }), _jsx(FieldArray, { name: "to", required: true, singleChoice: false, fieldLabel: "To", touch: touch, change: this.props.change, showSearch: true, component: ListUserEmailOptionsCcBcc, elementItem: this.renderElementItem, availableOptions: users, status: composeEmailMeta.findUser, getfunction: composeEmailFindUser, placeholder: "Search for recipients..." })] })), _jsxs("div", Object.assign({ className: "cc-bcc-row" }, { children: [_jsx(FieldArray, { name: "cc", required: false, singleChoice: false, fieldLabel: "Cc", touch: touch, showSearch: this.state.ccVisible, hideField: this.hideField, change: this.props.change, component: ListUserEmailOptionsCcBcc, elementItem: this.renderElementItem, availableOptions: users, status: composeEmailMeta.findUser, getfunction: composeEmailFindUser, placeholder: "Search for Cc recipients..." }), _jsx(FieldArray, { name: "bcc", required: false, singleChoice: false, fieldLabel: "Bcc", touch: touch, showSearch: this.state.bccVisible, hideField: this.hideField, change: this.props.change, component: ListUserEmailOptionsCcBcc, elementItem: this.renderElementItem, availableOptions: users, status: composeEmailMeta.findUser, getfunction: composeEmailFindUser, placeholder: "Search for Bcc recipients..." })] }))] }))), _jsx("div", Object.assign({ className: "conversation-form__editorwrap" }, { children: _jsx(RichTextField, { className: "conversation-form__editornew", ref: this.newEditorRef, onTriggerSend: handleSubmit(this.handleValidatedMessageOnSendClick), renderTemplate: this.renderTemplate, onChange: this.handleTypingEvent, channel: metaConversation.conversation.initial_channel, requesterName: this.props.isPublicReply
                            ? this.getRequesterHandleOrFallbackToName()
                            : this.getRequesterName(), attachments: formValues && formValues.attachments ? formValues.attachments : [], attachmentsFields: 
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        _jsx(FieldArray, { name: "attachments", component: AttachmentsFieldList }), validation: this.state.validation, setValidationState: this.setValidationState, form: getConversationFormName(csid), hasBorder: false, isPublicReply: this.props.isPublicReply }) })), showSubmitButton && (_jsx("div", Object.assign({ className: "conversation-form__submit" }, { children: _jsx(Tooltip, Object.assign({ content: submitBtnTooltip, dark: true, wrap: "div" }, { children: _jsx(Button, Object.assign({ type: "submit", disabled: disableSubmit }, { children: submitBtnText })) })) })))] })));
    }
}
export default reduxForm({
    validate: validate,
})(ConversationForm);
